//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageUploader from "../../components/ImageUploader";
import {checkIdCard, getBirthdayAndSex} from "../certificate/cert";
import {createOtherOwners} from '../../api/delivery'

export default {
    name: "page-other-owner",
    components: {
        ImageUploader
    },
    props: {
        deliveryRecordId: {
            required: true, Type: Number
        },
        roomId: {
            required: true, Type: Number
        },
    },
    data() {
        return {
            saving: false,
            otherOwnerDto: {
                id: 0,
                identityImage: {},
                cardType: 0,
                cardTypeStr: '居民身份证'
            },
            show: false,
            showCardType: false,
            cardTypeActions: [{name: '居民身份证'}, {name: '护照'}, {name: '军官证'}, {name: '营业执照'}],
            otherOwnerList: [],
            isCreate: false,
            delOtherOwners: []
        }
    },
    methods: {
        onCardTypeSelect(item) {
            this.otherOwnerDto.cardTypeStr = item.name;
            this.cardType(item.name);
            this.showCardType = false;
        },
        cardType(name) {
            if (name === '居民身份证') {
                this.otherOwnerDto.cardType = 0;
            } else if (name === '护照') {
                this.otherOwnerDto.cardType = 1;
            } else if (name === '军官证') {
                this.otherOwnerDto.cardType = 2;
            } else if (name === '营业执照') {
                this.otherOwnerDto.cardType = 3;
            }
        },
        onCancel() {
            this.showCardType = false
        },

        onSave() {
            if (!this.otherOwnerDto.name) {
                this.$toast('请输入业主姓名')
                return
            }

            if (!/^1[3-9]\d{9}$/.test(this.otherOwnerDto.phoneNumber)) {
                this.$toast('手机号格式错误')
                return
            }
            // console.log(this.otherOwnerDto)
            if (this.otherOwnerDto.cardType < 0 || this.otherOwnerDto.cardType === undefined) {
                this.$toast('请选择证件类型')
                return
            }

            if (!this.otherOwnerDto.cardNum) {
                this.$toast('请输入证件号')
                return
            }

            if (this.otherOwnerDto.cardType === 0) {
                if (!checkIdCard(this.otherOwnerDto.cardNum)) {
                    this.$toast('身份证号填写有误');
                    return;
                } else {
                    const info = getBirthdayAndSex(this.otherOwnerDto.cardNum);
                    console.log(info)
                    this.otherOwnerDto.birthday = info.birthDay;
                    //  0代表女性，不为0代表男性
                    this.otherOwnerDto.gender = info.sex === 0 ? 2 : 1;
                }
            }

            if (this.isCreate) {
                this.otherOwnerList.push(this.otherOwnerDto)
            }
            this.show = false
        },
        onEditOwner(row) {
            this.isCreate = false
            this.otherOwnerDto = {}
            // this.otherOwnerDto = JSON.parse(JSON.stringify(row))
            this.otherOwnerDto = row
            this.otherOwnerDto.identityImage = {}
            this.show = true

        },
        onCreateOwner(row) {
            this.isCreate = true
            this.otherOwnerDto = {}
            // this.otherOwnerDto = JSON.parse(JSON.stringify(row))
            this.otherOwnerDto = row
            this.otherOwnerDto.identityImage = {}
            this.show = true
        },

        getOtherOwner() {
            let vm = this;
            abp.ajax.get('/api/services/app/DeliveryRecord/GetOtherOwnerByRecordId?recordId=' + this.deliveryRecordId).then(res => {
                this.otherOwnerList = []
                this.otherOwnerList.push(...res.data.result)
                if (this.otherOwnerList.length > 0) {
                    this.otherOwnerList.forEach(item => {
                        item.identityImage = {}
                    })
                }
            })
        },

        onHandleDel(row) {
            if (row.id > 0) {
                let i = this.otherOwnerList.findIndex(z => z.id === row.id);
                this.otherOwnerList.splice(i, 1)
                this.delOtherOwners.push(this.otherOwnerList[i]);
            } else {
                let index = this.otherOwnerList.findIndex(z => z.name === row.name && z.phoneNumber === row.phoneNumber)
                this.otherOwnerList.splice(index, 1)
            }
        },

        onSaveOtherOwner() {
            let page = {
                addMembers: this.otherOwnerList,
                delMembers: this.delOtherOwners,
                roomId: this.roomId
            }
            createOtherOwners(page).then(res => {

            })
        }
        // onSave() {
        //     let page = {
        //         addMembers: [],
        //         delMembers: []
        //     }
        // }
    },
    created() {
        this.getOtherOwner()
    }
}
